import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDrawer2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"drawer-2"} maskId="square-filled-radius-0-stroke-1-IconDrawer2"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V19H18V22H17V19H7V22H6V19H3V3ZM4 11.5V18H11.5V11.5H4ZM11.5 10.5H4V4H11.5V10.5ZM15 9V13H14V9H15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDrawer2;
